import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();

  // Check if the current route is /terms or /policy
  const isSpecialRoute = location.pathname === '/terms' || location.pathname === '/policy';

  return (
    <nav
      className="navbar"
      style={{ backgroundColor: isSpecialRoute ? 'rgba(0, 0, 0, 0.5)' : 'transparent' }}
    >
      <div className="navbar-logo" onClick={() => navigate('/')}>
        <img src="/images/logo.png" alt="Logo" />
      </div>
      <div className="navbar-links">
        <NavLink to="/contact" activeClassName="active-link">
          Contact
        </NavLink>
      </div>
    </nav>
  );
}

export default Navbar;